'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get2 = require('./internal/_get');

var _get3 = _interopRequireDefault(_get2);

var _reduce2 = require('./internal/_reduce');

var _reduce3 = _interopRequireDefault(_reduce2);

var _set2 = require('./internal/_set');

var _set3 = _interopRequireDefault(_set2);

var _curry = require('./curry');

var _curry2 = _interopRequireDefault(_curry);

var _immutable = require('immutable');

var _getIn = require('./getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _isRecord = require('./isRecord');

var _isRecord2 = _interopRequireDefault(_isRecord);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getInOp = _getIn2.default.operation;

function runTransform(transform, newKey, subject) {
  if (typeof transform === 'function') {
    return transform(subject, newKey);
  }
  if (transform === true) {
    return (0, _get3.default)(newKey, subject);
  }
  if (Array.isArray(transform)) {
    return getInOp(transform, subject);
  }
  return (0, _get3.default)(transform, subject);
}

function translate(translation, subject) {
  var result = (0, _isRecord2.default)(subject) ? (0, _immutable.Map)() : new subject.constructor();
  return (0, _reduce3.default)(result, function (acc, transform, newKey) {
    return (0, _set3.default)(newKey, runTransform(transform, newKey, subject), acc);
  }, translation);
}

exports.default = (0, _curry2.default)(translate);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.3/translate.js
// module id = 393
// module chunks = 0 1